import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import axios from 'axios';
import { toast } from 'react-toastify';
import {
    CreateChancel,
    CustomNumericFormat,
    SelectTypeAutocomplete,
    TimeInput,
    DateTypeSelect,
    AddressTypeSelect,
    NotError,
    SelectAutocompletePagination,
    ValidationInput,
    SelectAutocompletePaginationMultiple,
    CustomizedSwitch,
    ToolInfo,
    MultiStaffBox,
} from 'components';
import {
    ErrorText,
    FindLoad,
    Images,
    FindErrorItem,
    useModal,
    renderStaffName,
    staffStatusEnums,
    reqTypeEnums,
    SaveParams,
    FindSuccessItem,
} from 'utils';
import { scheduleModalsStyle } from './styles';
import { adminActions, appointmentActions, httpRequestsOnErrorsActions, httpRequestsOnSuccessActions, payrollActions } from 'store';
import {
    apptOverlap,
    changeDateTime,
    checkBreakRequiresFields,
    checkDateSelector,
    defaultInitialInputs,
    getStartEndAppt,
    mergePayCodes,
    renderTimes,
    staffOverlap,
} from './constants';
import { DRIVE, scheduleStatuses, SERVICE, STAFF, UNPAID } from '../../constants';
import { ModalHeader } from './common';
import { CreateMultiple } from './createMultiple';
import { EditMultiple } from './editMultiple';
import { ConfMultiple } from './confMultiple';
import { TemplateApptActions } from './common/templateApptActions';
import { ApptErrors } from './common/apptErrors';
import { checkCreatePermission, SubjectEnums } from '../constants';
import { MULTI_STAFF_OVERLAPPING } from '../../../../store/appointment/appointment.type';
import { StaffOverlapping } from './common/staffOverlapping';

export const Break = ({ handleOpenClose, type, date, modalDate, duplicate }) => {
    const { allPaycodes, appts, appointmentDates } = useSelector((state) => ({
        allPaycodes: state.admins.allPaycodes,
        appts: state.appointment.appts,
        appointmentDates: state.appointment.appointmentDates,
    }));
    const editActionType = modalDate ? 'EDIT_APPOINTMENT' : 'CREATE_APPOINTMENT';
    const classes = scheduleModalsStyle();
    const dispatch = useDispatch();
    const location = useLocation();
    const info = location?.state;
    const createModalDate = location?.state;
    const [inputs, setInputs] = useState(createModalDate ? { ...createModalDate } : {});
    const [error, setError] = useState('');
    const backError = FindErrorItem(editActionType);
    const loader = FindLoad(editActionType);
    const [createMultiple, setCreateMultiple] = useState(false);
    const [occurrence, setOccurrence] = useState(0);
    const [state, setState] = React.useState([]);
    const GET_ALL_PAY_CODES = 'GET_ALL_PAY_CODES';
    const GET_GLOBAL_PAY_CODES = 'GET_PAY_CODE_GLOBAL';
    const APPOINTMENT_FROM_TEMPLATE = 'APPOINTMENT_FROM_TEMPLATE';
    const { open } = useModal();
    const uniquePayCodes = mergePayCodes(allPaycodes);
    const [apptLocations, setApptLocations] = useState({});
    const [distanceInformation, setDistanceInformation] = useState(null);
    const [errorList, setErrorList] = useState([]);
    const resetParams = modalDate ? modalDate : duplicate ? duplicate : null;
    const apptBetweenDates = {
        startDate: moment.utc(inputs?.betweenStartDate ? inputs?.betweenStartDate : appointmentDates?.startDate).format('YYYY-MM-DD'),
        endDate: moment.utc(inputs?.betweenEndDate ? inputs.betweenEndDate : appointmentDates?.endDate).format('YYYY-MM-DD'),
    };
    const [multiStaffSelect, setMultiStaffSelect] = useState(false);
    const reqType = checkCreatePermission(type);
    const globalPayCodes = useSelector((state) => state.payroll.payCodes);
    const staffOverlapping = FindSuccessItem(MULTI_STAFF_OVERLAPPING);

    useEffect(() => {
        setApptLocations({});
    }, []);

    useEffect(() => {
        if (staffOverlapping) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(MULTI_STAFF_OVERLAPPING));
            open(<StaffOverlapping apptInfo={apptInfo()} overlappingList={staffOverlapping?.data} />);
        }
    }, [staffOverlapping]);

    useEffect(() => {
        if (multiStaffSelect) {
            dispatch(payrollActions.getPayCodeGlobal());
        }
    }, [multiStaffSelect]);

    useEffect(() => {
        if (info?.staff && !modalDate && !duplicate && reqType === reqTypeEnums.ALL) {
            setInputs((prev) => ({
                ...prev,
                staff: info?.staff,
            }));
        }
    }, [info]);

    useEffect(() => {
        if (appointmentDates && (!inputs?.betweenStartDate || !inputs?.betweenEndDate)) {
            setInputs((prev) => ({
                ...prev,
                betweenStartDate: appointmentDates?.startDate,
                betweenEndDate: appointmentDates?.endDate,
            }));
        }
    }, [appointmentDates]);

    useEffect(() => {
        if (
            appts?.appts?.length &&
            inputs?.staff &&
            inputs?.startDate &&
            inputs?.startTime &&
            inputs?.endTime &&
            !distanceInformation &&
            type === DRIVE
        ) {
            const params = getStartEndAppt(appts, inputs);
            if (!params?.from && resetParams?.startAddress) {
                params.from = resetParams?.startAddress;
            }
            if (!params?.to && resetParams?.endAddress) {
                params.to = resetParams?.endAddress;
            }

            setApptLocations(params);
            handleChangeLocation(null, params);
        }
        // else {
        //     if (!appts?.appts?.length) {
        //         setApptLocations({});
        //         setDistanceInformation(null);
        //     }
        // }
    }, [inputs?.staff, inputs?.startDate, inputs?.startTime, inputs?.endTime, appts]);

    useEffect(() => {
        if (error) {
            setError('');
            dispatch(httpRequestsOnErrorsActions.removeError(editActionType));
            dispatch(httpRequestsOnErrorsActions.removeError('APPOINTMENT_OVERLAPPING'));
        }
        dispatch(adminActions.removeAdminById());
        dispatch(appointmentActions.removeAppointmentDates());
    }, []);

    useEffect(() => {
        if (resetParams) {
            getStaffPayCodes(resetParams?.staff?.id);
            const params = {
                type: resetParams?.type,
                staff: resetParams?.staff?.id,
                payCodeType: resetParams?.payCodeTypeId,
                startDate: resetParams?.startDate,
                startTime: resetParams.startTime?.slice(11, 16),
                endTime: resetParams.endTime?.slice(11, 16),
                staffApptType: resetParams?.staffApptType,
            };

            if (resetParams?.startAddress || resetParams?.endAddress) {
                setApptLocations({
                    from: resetParams?.startAddress,
                    to: resetParams?.endAddress,
                });
            }
            if (resetParams?.miles) {
                params.miles = modalDate?.miles;
            }
            if (resetParams?.subject) {
                params.subject = resetParams?.subject;
            }
            setInputs(params);
        }
        if (!resetParams && date) {
            setInputs({
                startTime: date?.startTime?.slice(11, 16),
                endTime: date?.endTime?.slice(11, 16),
                startDate: date?.startDate && moment.utc(date?.startDate).format('YYYY-MM-DD'),
                // startDate: date?.startDate,
                staff: info?.staff,
            });
        }
    }, [resetParams, date]);

    const apptInfo = () => {
        const apptDate = {
            type: type,
            startDate: inputs?.startDate && moment.utc(inputs?.startDate).format('YYYY-MM-DD'),
            startTime: changeDateTime(inputs?.startDate, inputs?.startTime),
            endTime: changeDateTime(inputs?.startDate, inputs?.endTime),
            staff: inputs?.staff,
            payCodeType: inputs?.payCodeType,
            editTemplate: createMultiple,
        };

        if (multiStaffSelect) {
            apptDate.staffs = inputs?.staffs?.map((i) => i?.id);
            delete apptDate.staff;
        }

        if (type === DRIVE) {
            apptDate.miles = inputs.miles ? +inputs.miles : (apptDate.miles = 0);

            if (apptLocations?.from) {
                apptDate.startAddress = apptLocations?.from;
            }
            if (apptLocations?.to) {
                apptDate.endAddress = apptLocations?.to;
            }
        }
        if (type === STAFF) {
            apptDate.staffApptType = inputs?.staffApptType;
            apptDate.subject = inputs?.subject;
        }

        if (createMultiple) {
            apptDate.endDate = moment.utc(inputs.endDate).format('YYYY-MM-DD');
            if ((modalDate && inputs?.betweenStartDate) || inputs?.betweenEndDate) {
                apptDate.updateBetween = {
                    startDate: inputs?.betweenStartDate ? moment.utc(inputs?.betweenStartDate).format('YYYY-MM-DD') : null,
                    endDate: inputs?.betweenEndDate ? moment.utc(inputs?.betweenEndDate).format('YYYY-MM-DD') : null,
                };
            }
        }
        return apptDate;
    };

    useEffect(() => {
        if (backError?.error === apptOverlap || backError?.error === staffOverlap) {
            setError(ErrorText.overlappingError('Appointments'));
            dispatch(httpRequestsOnErrorsActions.removeError('APPOINTMENT_OVERLAPPING'));
        }
    }, [backError]);

    const getStaffPayCodes = (id) => {
        dispatch(adminActions.getAllPayCodes(id));
    };

    useEffect(() => {
        if (createModalDate && createModalDate?.staff) {
            getStaffPayCodes(createModalDate.staff);
        }
    }, [createModalDate]);

    useEffect(() => {
        if (info?.staff) {
            getStaffPayCodes(info?.staff);
        }
    }, [info]);

    useEffect(() => {
        return () => dispatch(adminActions.clearAllPayCodes());
    }, []);

    const handleCloseModal = () => {
        handleOpenClose && handleOpenClose();
        setInputs({});
    };

    const handleChangeLocation = (e, alreadySelected) => {
        if (!alreadySelected) {
            setApptLocations((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
        }
        setDistanceInformation(null);
        const startAddress = alreadySelected ? alreadySelected?.from : e.target.name === 'from' ? e.target.value : apptLocations?.from;
        const endAddress = alreadySelected ? alreadySelected?.to : e.target.name === 'to' ? e.target.value : apptLocations?.to;

        if (startAddress && endAddress) {
            const fromRoute = `${startAddress?.lat},${startAddress?.lng}`;
            const toRoute = `${endAddress?.lat},${endAddress?.lng}`;
            const apiKey = '448b7c0b-9165-43ff-801f-b6f2565a2e24';
            const url = `https://graphhopper.com/api/1/route?point=${fromRoute}&point=${toRoute}&vehicle=car&locale=en&calc_points=true&key=${apiKey}`;
            try {
                axios
                    .get(url, { calc_points: true, key: apiKey, useBaseUrl: false })
                    .then((response) => {
                        const data = response.data.paths[0];
                        const distanceInMiles = ((data.distance / 1000) * 0.621371).toFixed(2);
                        const durationInMinutes = data.time / 60000;
                        const days = Math.floor(durationInMinutes / (60 * 24));
                        const hours = Math.floor((durationInMinutes % (60 * 24)) / 60);
                        const minutes = Math.floor(durationInMinutes % 60);
                        setDistanceInformation({
                            distance: distanceInMiles,
                            time: `${days ? `${days}d` : ''}${hours ? `${hours}h` : ''}${minutes ? `${minutes}m` : ''}`,
                        });
                    })
                    .catch((error) => {
                        if (error?.data?.message) {
                            toast(<NotError type={'error'} errMessage={error?.data?.message} />);
                        }
                    });
            } catch (error) {}
        }
    };

    useEffect(() => {
        if (inputs?.staff && inputs?.startDate && inputs?.startTime && inputs?.endTime && type === DRIVE) {
            dispatch(
                appointmentActions.getAppointmentByFilters({
                    startDate: inputs?.startDate && moment.utc(inputs?.startDate).format('YYYY-MM-DD'),
                    endDate: inputs?.startDate && moment.utc(inputs?.startDate).format('YYYY-MM-DD'),
                    type: SERVICE,
                })
            );
            // setApptLocations({});
            setDistanceInformation(null);
        }
    }, [inputs?.staff, inputs?.startDate, inputs?.startTime, inputs?.endTime]);

    const handleChange = (e) => {
        error === e.target.name && setError('');

        // if (e.target.name === 'startDate') {
        //     dispatch(appointmentActions.getAppointmentByFilters({
        //         startDate: e.target.value,
        //         endDate: e.target.value,
        //         type: SERVICE,
        //     }));
        // }

        if (e.target.name === 'staff') {
            if (e?.target?.value) {
                getStaffPayCodes(e.target.value);
                dispatch(adminActions.getAdminById(e.target.value));
            } else {
                dispatch(adminActions.removeAdminById());
                dispatch(adminActions.clearAllPayCodes());
            }

            const newParams = {
                ...inputs,
                staff: e.target.value,
            };
            delete newParams.payCodeType;
            setInputs(newParams);
        } else {
            if (e.target.name === 'payCodeType') {
                const params = {
                    ...inputs,
                };
                params[e.target.name] = e.target.value;
                setInputs(params);
            } else if (e.target.name === 'staffApptType') {
                const params = {
                    ...inputs,
                };
                params[e.target.name] = e.target.value;
                params['subject'] = SubjectEnums.find((i) => i?.id === e.target.value)?.name;
                setInputs(params);
            } else {
                setInputs((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
            }
        }

        if (error === e.target.name || error === ErrorText.timeError || error === ErrorText.overlappingError('Appointments')) {
            setError('');
        }
        if (backError) {
            dispatch(httpRequestsOnErrorsActions.removeError(backError?.type));
        }
    };

    const handleChangeMiles = (value) => {
        setInputs((prevState) => ({ ...prevState, ['miles']: value?.value }));
        if (error === 'miles') setError('');
    };

    const handleCreate = () => {
        const date = apptInfo();
        const apptCreateVerification = checkBreakRequiresFields(inputs, createMultiple, type, '', multiStaffSelect);

        if (apptCreateVerification === 'valid') {
            if (modalDate?.id) {
                dispatch(appointmentActions.editAppointment(date, modalDate?.id));
            } else {
                dispatch(appointmentActions.createAppointment(date));
            }
        } else {
            setError(apptCreateVerification);
        }
    };

    function createMultipleAppt() {
        const week = {
            startDate: new Date(inputs.startDate),
            endDate: new Date(inputs.endDate),
            mode: inputs.mode,
            repeatCountWeek: +inputs.repeatCountWeek,
            repeatCheckWeek: [...state],
        };

        const mounthObject = {
            startDate: new Date(inputs.startDate),
            endDate: new Date(inputs.endDate),
            mode: inputs.mode,
            repeatDayMonth: +inputs.repeatDayMonth,
            repeatMonth: +inputs.repeatMonth,
        };

        !inputs.repeatDayMonth ? delete mounthObject['repeatDayMonth'] : '';
        !inputs.repeatMonth ? delete mounthObject['repeatMonth'] : '';

        const newObject = {
            startDate: new Date(inputs.startDate),
            endDate: new Date(inputs.endDate),
            mode: inputs.mode,
        };

        if (inputs.repeatConsecutive === 'repeatConsecutive') {
            newObject.repeatConsecutive = true;
        } else {
            newObject.repeatCount = +inputs.repeatCount;
        }
        const obj = inputs.mode === 'WEEKLY' ? week : inputs.mode === 'MONTHLY' ? mounthObject : newObject;

        const apptVerification = checkBreakRequiresFields(inputs, createMultiple, type, state, multiStaffSelect);

        if (apptVerification === 'valid') {
            const checkParams = {
                staffId: inputs?.staff,
                startTime: changeDateTime(obj?.startDate, inputs?.startTime),
                endTime: changeDateTime(obj?.endDate, inputs?.endTime),
            };

            const apptData = {
                staffId: inputs?.staff,
                ...apptInfo(),
                template: {
                    ...obj,
                },
            };

            if (multiStaffSelect) {
                delete apptData.staffId;
                delete checkParams.staffId;
                checkParams.staffIds = inputs?.staffs?.map((i) => i?.id);
                apptData.staffIds = inputs?.staffs?.map((i) => i?.id);
            } else {
                checkParams.staffId = inputs?.staff;
                apptData.staffId = inputs?.staff;
            }

            open(
                <ConfMultiple
                    recurInfo={obj}
                    handleSubmit={() =>
                        dispatch(
                            appointmentActions.appointmentFromTemplate({
                                pattern: { ...obj },
                                apptData: apptData,
                            })
                        )
                    }
                    loadType={APPOINTMENT_FROM_TEMPLATE}
                    occurrence={occurrence}
                    checkParams={checkParams}
                />
            );
        } else {
            setError(apptVerification);
        }
    }

    function editMultipleAppt() {
        if (modalDate?.id && createMultiple) {
            const apptEditVerification = checkBreakRequiresFields(inputs, false, type, state);

            if (apptEditVerification === 'valid') {
                const startTime = changeDateTime(modalDate?.startDate, inputs?.startTime);
                const endTime = changeDateTime(modalDate?.startDate, inputs?.endTime);

                const sendParams = {
                    ...apptInfo(),
                    startTime: startTime,
                    endTime: endTime,
                };
                delete sendParams.startDate;
                delete sendParams.endDate;

                open(
                    <EditMultiple
                        modalDate={{
                            // ...modalDate,
                            templateId: modalDate?.template,
                            startTime: startTime,
                            endTime: endTime,
                            staffId: inputs?.staff,
                        }}
                        handleSubmit={() => dispatch(appointmentActions.editAppointment(sendParams, modalDate?.id))}
                        loadType={editActionType}
                        occurrence={occurrence}
                        dateBetween={{
                            startDate: inputs?.betweenStartDate ? moment.utc(inputs?.betweenStartDate).format('YYYY-MM-DD') : null,
                            endDate: inputs?.betweenEndDate ? moment.utc(inputs?.betweenEndDate).format('YYYY-MM-DD') : null,
                        }}
                    />
                );
            } else {
                setError(apptEditVerification);
            }
        }
    }

    const setMultipleAppts = () => {
        setCreateMultiple(!createMultiple);
        if (modalDate) {
            const params = {
                ...inputs,
            };
            delete params.endDate;
            params.startDate = modalDate.startDate;
            setInputs(params);
        } else {
            const params = {
                ...inputs,
                ...defaultInitialInputs,
            };
            delete params.startDate;
            delete params.endDate;
            setInputs(params);
        }
    };

    const editRepeat = (e) => {
        setInputs(e);
        if (backError?.error) {
            dispatch(httpRequestsOnErrorsActions.removeError(editActionType));
        }
        if (error === 'repeat') {
            setError('');
        }
    };

    const handleSelectStaffs = (e) => {
        if (error === e?.target?.name) {
            setError('');
        }
        setInputs((prevState) => ({ ...prevState, ['staffs']: e.target.full }));
    };

    return (
        <div>
            <ModalHeader modalDate={modalDate} type={type} createMultiple={createMultiple} setMultipleAppts={setMultipleAppts} />

            <div className={classes.breakWrapper}>
                <div className="flex-align-start full-width" style={{ gap: 24 }}>
                    <div className="full-width">
                        <div className="space-between" style={{ gap: 8 }}>
                            <p className="date-time-text">Staff</p>
                            {type === STAFF && !modalDate && (
                                <div className={classes.signatureStyle} style={{ marginTop: '-6px' }}>
                                    <ToolInfo
                                        background={'transparent'}
                                        text={'Each staff will receive a separate appt for the same time slot'}
                                    />
                                    <p>Multiple Staff</p>
                                    <CustomizedSwitch
                                        checked={multiStaffSelect}
                                        handleClick={() => {
                                            const params = { ...inputs };
                                            delete params.staff;
                                            delete params.staffs;
                                            setInputs(params);
                                            setError('');
                                            setMultiStaffSelect(!multiStaffSelect);
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                        {multiStaffSelect ? (
                            <div className={inputs?.staffs?.length ? 'multiple-staff-selector' : ''}>
                                <SelectAutocompletePaginationMultiple
                                    defaultStatuses={[staffStatusEnums.ACTIVE]}
                                    placeholder={inputs?.staffs?.length ? `${inputs?.staffs?.length} staff selected` : 'Staff Member*'}
                                    name={'staff'}
                                    handleSelect={handleSelectStaffs}
                                    typeError={error === 'staff' ? `Staff member ${ErrorText.isRequired}` : ''}
                                    error={error}
                                    defaultValue={inputs?.staffs ? inputs?.staffs : []}
                                    renderValue={(i) => renderStaffName(i)}
                                    type={'staff'}
                                    title={'Staff Member*'}
                                    noError={inputs?.staffs?.length}
                                />
                            </div>
                        ) : (
                            <SelectAutocompletePagination
                                style={'full-width'}
                                defaultStatuses={[staffStatusEnums.ACTIVE]}
                                title={'Staff Member*'}
                                name={'staff'}
                                handleSelect={handleChange}
                                defaultValue={inputs?.staff}
                                renderValue={(i) => renderStaffName(i)}
                                type={'staff'}
                                error={error}
                                typeError={error === 'staff' ? `Staff member ${ErrorText.isRequired}` : ''}
                                currentSelected={
                                    resetParams?.staff
                                        ? resetParams?.staff
                                        : info?.staffFull && reqType === reqTypeEnums.ALL
                                        ? info?.staffFull
                                        : null
                                }
                                autoSelect={reqType === reqTypeEnums.SELF && !resetParams?.id}
                                // singleSelect={true}
                            />
                        )}
                        {type === STAFF && multiStaffSelect && !!inputs?.staffs?.length && (
                            <div style={{ marginBottom: 12 }}>
                                <MultiStaffBox
                                    list={inputs?.staffs}
                                    removeAll={() => {
                                        const params = {
                                            ...inputs,
                                        };
                                        delete params.staffs;
                                        setInputs(params);
                                    }}
                                    removeSingle={(staff) => {
                                        const params = {
                                            ...inputs,
                                        };
                                        params.staffs = params?.staffs?.filter((i) => i?.id !== staff?.id);
                                        setInputs(params);
                                    }}
                                />
                            </div>
                        )}
                    </div>

                    <div className="full-width">
                        <p className="date-time-text">Paycode</p>
                        <div className="flex-align-center full-width" style={{ gap: 16 }}>
                            <SelectTypeAutocomplete
                                defaultSelected={resetParams?.payCodeTypeName && { name: resetParams?.payCodeTypeName }}
                                defaultValue={inputs?.payCodeType}
                                list={multiStaffSelect ? globalPayCodes : uniquePayCodes || []}
                                style={'full-width'}
                                disabled={
                                    modalDate?.status === scheduleStatuses?.COMPLETED ? true : multiStaffSelect ? false : !inputs?.staff
                                }
                                loadType={multiStaffSelect ? GET_GLOBAL_PAY_CODES : GET_ALL_PAY_CODES}
                                title={'Staff Paycode*'}
                                name={'payCodeType'}
                                handleSelect={handleChange}
                                error={error}
                                typeError={error === 'payCodeType' ? `Staff paycode ${ErrorText.isRequired}` : ''}
                                renderValue={(i) => i?.name}
                                refresh={() => {
                                    getStaffPayCodes(inputs?.staff);
                                }}
                            />
                        </div>
                    </div>
                </div>

                {type === STAFF && (
                    <div className="flex-align-center full-width" style={{ gap: 24 }}>
                        <SelectTypeAutocomplete
                            defaultSelected={resetParams?.staffApptType && { name: resetParams?.staffApptType }}
                            defaultValue={inputs?.staffApptType}
                            list={SubjectEnums || []}
                            style={'full-width'}
                            title={'Type*'}
                            name={'staffApptType'}
                            handleSelect={handleChange}
                            error={error}
                            typeError={error === 'staffApptType' ? `Type ${ErrorText.isRequired}` : ''}
                            renderValue={(i) => i?.name}
                        />
                        <ValidationInput
                            style={classes.credentialInputStyle}
                            onChange={handleChange}
                            value={inputs.subject}
                            variant={'outlined'}
                            name={'subject'}
                            label={'Subject*'}
                            type={'text'}
                            typeError={error === 'subject' && `Subject ${ErrorText.isRequired}`}
                        />
                    </div>
                )}

                <div className="flex-align-start" style={{ gap: 24 }}>
                    {checkDateSelector(modalDate, createMultiple) && (
                        <div className="full-width">
                            <p className="date-time-text">{createMultiple ? 'Date Range' : 'Date'}</p>
                            {createMultiple ? (
                                <div className="service-inputs-box">
                                    <DateTypeSelect
                                        type={'modalInput'}
                                        name={'startDate'}
                                        outLabel={'Start Date*'}
                                        handleGetDates={handleChange}
                                        values={inputs}
                                        error={error === 'startDate' && `Start date ${ErrorText.isRequired}`}
                                        max={inputs?.endDate ? moment.utc(inputs.endDate).format('YYYY-MM-DD') : ''}
                                    />
                                    <DateTypeSelect
                                        type={'modalInput'}
                                        name={'endDate'}
                                        outLabel={'End Date*'}
                                        handleGetDates={handleChange}
                                        values={inputs}
                                        error={error === 'endDate' && `End date ${ErrorText.isRequired}`}
                                        min={inputs?.startDate ? moment.utc(inputs.startDate).format('YYYY-MM-DD') : ''}
                                    />
                                </div>
                            ) : (
                                <DateTypeSelect
                                    type={'modalInput'}
                                    name={'startDate'}
                                    outLabel={'Start Date*'}
                                    handleGetDates={handleChange}
                                    values={inputs}
                                    error={error === 'startDate' && `Start date ${ErrorText.isRequired}`}
                                />
                            )}
                        </div>
                    )}

                    <div className="full-width">
                        <p className="date-time-text">{'Time'}</p>
                        <div className={classes.timeInputs} style={{ gap: '16px' }}>
                            <TimeInput
                                label={'Start Time*'}
                                name={'startTime'}
                                onChange={handleChange}
                                typeError={
                                    error === 'startTime'
                                        ? `Start time ${ErrorText.isRequired}`
                                        : backError?.error === apptOverlap
                                        ? ErrorText.overlappingError('Appointments')
                                        : backError?.error === staffOverlap
                                        ? ErrorText.overlappingError('Appointments')
                                        : ''
                                }
                                defaultValue={inputs?.startTime ? renderTimes(inputs.startTime) || inputs.startTime : null}
                            />
                            <TimeInput
                                label={'End Time*'}
                                name={'endTime'}
                                onChange={handleChange}
                                typeError={
                                    error === 'endTime'
                                        ? `End time ${ErrorText.isRequired}`
                                        : error === ErrorText.timeError
                                        ? ErrorText.timeError
                                        : ''
                                }
                                defaultValue={inputs?.endTime ? renderTimes(inputs.endTime) || inputs.endTime : null}
                            />
                        </div>
                    </div>
                </div>

                {type === DRIVE && (
                    <div>
                        <div className="flex-align-start" style={{ gap: 24 }}>
                            <div className="full-width">
                                <p className="date-time-text">From</p>
                                <AddressTypeSelect
                                    disabled={!inputs?.startDate || !inputs?.startTime || !inputs?.endTime}
                                    title={'Starting Address'}
                                    name={'from'}
                                    handleSelect={handleChangeLocation}
                                    value={apptLocations?.from}
                                    list={apptLocations?.from ? [apptLocations?.from] : []}
                                    renderValue={(i) => i?.name}
                                    loadType={'GET_APPOINTMENT_BY_FILTERS'}
                                />
                            </div>
                            <div className="full-width">
                                <p className="date-time-text">To</p>
                                <AddressTypeSelect
                                    disabled={!inputs?.startDate || !inputs?.startTime || !inputs?.endTime}
                                    title={'Ending Address'}
                                    name={'to'}
                                    handleSelect={handleChangeLocation}
                                    value={apptLocations?.to}
                                    list={apptLocations?.to ? [apptLocations?.to] : []}
                                    renderValue={(i) => i?.name}
                                    loadType={'GET_APPOINTMENT_BY_FILTERS'}
                                />
                            </div>
                        </div>

                        {distanceInformation?.distance && (
                            <div className="apply-miles-wrapper">
                                <div className="flex-align-center" style={{ gap: 4 }}>
                                    <p>Estimated Time & Distance:</p>
                                    <span>{`${distanceInformation?.time ? `${distanceInformation?.time} | ` : ''}  ${
                                        distanceInformation?.distance
                                    } miles`}</span>
                                </div>
                                <button
                                    onClick={() => {
                                        setInputs({
                                            ...inputs,
                                            miles: distanceInformation?.distance,
                                        });
                                    }}>
                                    Apply Miles
                                </button>
                            </div>
                        )}

                        <div className="flex-align-start" style={{ gap: 24 }}>
                            <div className="full-width">
                                <CustomNumericFormat
                                    name={'miles'}
                                    label={'Miles'}
                                    value={inputs?.miles}
                                    error={error === 'miles' ? `Miles ${ErrorText.isRequired}` : ''}
                                    handleChangeMiles={handleChangeMiles}
                                    thousandSeparator={','}
                                    errorName={error}
                                />
                            </div>
                            <div className="full-width" />
                        </div>
                    </div>
                )}

                {modalDate?.id && createMultiple && (
                    <div className="template-date-range">
                        <p className="date-time-text">Date Range</p>
                        <div className="service-inputs-box">
                            <DateTypeSelect
                                type={'modalInput'}
                                name={'betweenStartDate'}
                                outLabel={'Start Date'}
                                handleGetDates={handleChange}
                                values={inputs}
                                error={error === 'betweenStartDate' && `Start date ${ErrorText.isRequired}`}
                                noError={true}
                                min={apptBetweenDates?.startDate}
                                max={apptBetweenDates?.endDate}
                            />
                            <DateTypeSelect
                                type={'modalInput'}
                                name={'betweenEndDate'}
                                outLabel={'End Date'}
                                handleGetDates={handleChange}
                                values={inputs}
                                error={error === 'betweenEndDate' && `End date ${ErrorText.isRequired}`}
                                noError={true}
                                min={apptBetweenDates?.startDate}
                                max={apptBetweenDates?.endDate}
                            />
                        </div>

                        <div className="changes-will-apply">
                            <img src={Images.toolInfoIcon} alt={'icon'} />
                            <p>Changes will apply to all appointments between these dates.</p>
                        </div>
                    </div>
                )}
                {createMultiple && (
                    <CreateMultiple
                        handleClose={handleOpenClose}
                        modalDate={modalDate}
                        state={state}
                        setState={setState}
                        inputs={{ ...inputs }}
                        setInputs={editRepeat}
                        setOccurrence={setOccurrence}
                        error={error}
                    />
                )}
                <ApptErrors
                    inputs={inputs}
                    backError={backError}
                    createMultiple={createMultiple}
                    setErrorList={setErrorList}
                    errorList={errorList}
                    modalDate={modalDate}
                />
                <div className={classes.actionBtnBox}>
                    {modalDate?.id && createMultiple ? (
                        <TemplateApptActions
                            apptDate={modalDate}
                            handleClose={handleOpenClose}
                            handleSave={editMultipleAppt}
                            loader={!!loader.length}
                            disabled={errorList?.length !== 0}
                            apptBetweenDates={apptBetweenDates}
                        />
                    ) : (
                        <CreateChancel
                            buttonWidth={'100%'}
                            cancelRight={'24px'}
                            loader={!!loader.length}
                            create={
                                modalDate?.id && createMultiple
                                    ? 'Update'
                                    : modalDate
                                    ? 'Save'
                                    : createMultiple
                                    ? `Add ${occurrence ? occurrence : 0} Appointments`
                                    : 'Add Appointment'
                            }
                            chancel={'Cancel'}
                            onCreate={createMultiple ? createMultipleAppt : handleCreate}
                            onClose={handleCloseModal}
                            disabled={errorList?.length !== 0}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};
